import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "deleteForm"]

  connect() {
    // Listen for form submission on the delete form only (after confirmation)
    if (this.hasDeleteFormTarget) {
      this.deleteFormTarget.addEventListener('turbo:submit-start', this.handleDelete.bind(this))
    }
  }

  disconnect() {
    if (this.hasDeleteFormTarget) {
      this.deleteFormTarget.removeEventListener('turbo:submit-start', this.handleDelete.bind(this))
    }
  }

  handleDelete(event) {
    // Get the container element
    const container = this.containerTarget

    // Add transition classes for smooth animation
    container.style.transition = 'all 0.3s ease-out'
    container.style.overflow = 'hidden'

    // Animate out: opacity and slide
    container.style.opacity = '0'
    container.style.transform = 'translateX(-100%)'

    // Collapse the height for smooth removal
    setTimeout(() => {
      const height = container.scrollHeight
      container.style.height = `${height}px`

      // Force reflow
      container.offsetHeight

      // Collapse to 0
      container.style.height = '0'
      container.style.marginBottom = '0'
      container.style.paddingTop = '0'
      container.style.paddingBottom = '0'

      // Remove from DOM after collapse animation
      setTimeout(() => {
        container.remove()
      }, 300)
    }, 300)
  }
}
